import api from "./api";

//Segun oobtiene los invenarios del usuario asociados, pero no se usa
export const getUserInventories = async () => {
    try {
      const response = await api.get('inventories/list/'); // Ajusta la URL si es diferente
      if (response.data.success) {
        return response.data.inventarios;
      } else {
        console.warn("Respuesta sin éxito:", response.data);
        return [];
      }
    } catch (error) {
      console.error("Error al obtener inventarios del usuario:", error);
      throw error;
    }
};

export const getUserInventoriesCreator = async () => {
  try {
    const response = await api.get('inventories/list/creator'); // Ajusta la URL si es diferente
    if (response.data.success) {
      return response.data.inventarios;
    } else {
      console.warn("Respuesta sin éxito:", response.data);
      return [];
    }
  } catch (error) {
    console.error("Error al obtener inventarios del usuario:", error);
    throw error;
  }
};


// Este servicio obtiene los inventarios en donde se relaciona el usuario actual, incluyendo el rol de cada uno
export const getDetailedUserInventories = async () => {
    try {
      const response = await api.get("inventories/details/");
      if (response.data.success) {
        return response.data.inventarios;
      }
      return [];
    } catch (error) {
      console.error("Error al obtener inventarios detallados:", error);
      return [];
    }
};

export const getVendedorCreadorInventario = async (fiInventario) => {
  try {
    const response = await api.get(`inventories/vendedor/creador/${fiInventario}/`);
    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Respuesta inesperada:", response.data);
      return null;
    }
  } catch (error) {
    console.error("Error al obtener el vendedor creador del inventario:", error);
    throw error;
  }
};

